const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2C4"
    },
    d: "M113.854,97.749c33.912-45.329,87.642-49.932,105.599-51.47 c13.216-1.132,103.196-8.84,151.999,69.219c37.568,60.089,34.204,144.56-6.4,200.557c-53.201,73.371-158.047,80.914-223.198,21.298 C74.885,276.073,67.38,159.869,113.854,97.749z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M113.868,464.72c0,5.321,37.241,9.634,83.181,9.634c45.939,0,83.18-4.313,83.18-9.634 c0-5.32-37.241-9.633-83.18-9.633C151.109,455.087,113.868,459.4,113.868,464.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M266.2,467.223c0,3.995,30.715,7.233,68.603,7.233c37.888,0,68.603-3.238,68.603-7.233 c0-3.995-30.715-7.233-68.603-7.233C296.915,459.99,266.2,463.228,266.2,467.223z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 128.087,
    transform: "matrix(0.6364 -0.7714 0.7714 0.6364 -34.7318 232.2934)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.829,
    height: 49.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M209.734,134.878c0.865,0.941,1.078,2.153,0.475,2.707c-0.602,0.554-1.792,0.239-2.657-0.702 c-0.865-0.941-1.078-2.153-0.475-2.707C207.679,133.623,208.869,133.937,209.734,134.878z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.597,144.906l14.06,173.114c0,0,8.788,35.15-99.299,7.909l26.143-146.312L379.597,144.906z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#29211C"
    },
    cx: 369.711,
    cy: 60.619,
    r: 9.619
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M358,65.634c1.662,4.429,4.602,7.421,6.566,6.684c1.965-0.737,2.21-4.925,0.548-9.353 c-1.662-4.429-4.602-7.421-6.566-6.684C356.583,57.018,356.338,61.205,358,65.634z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBC82"
    },
    points: "381.379,454.87 380.841,439.871 369.31,443.558 369.021,450.717 369.961,459.902  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29201D"
    },
    d: "M381.34,453.291c0,0,4.169,9.721,2.722,15.795c0,0-17.501,1.013-30.952,3.182 c-13.451,2.17-20.828-5.207-11.715-8.678c9.112-3.471,27.625-12.872,27.625-12.872S370.229,459.77,381.34,453.291z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBC82"
    },
    points: "324.899,452.7 324.361,437.701 312.829,441.388 312.54,448.548 313.48,457.732  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M317.605,239.416c0.205-12.512-0.103-17.948,2-30.511c0,0,0.536,19.319,48.88,1.258l5.345-1.441 c0,0,10.309,19.211,9.127,42.594c-0.17,3.367-0.858,6.695-1.906,9.899l-5.834,17.839L317.605,239.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M320.168,326.998 c0,0,3.73,6.171,7.312,6.646"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M320.168,326.998"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060"
    },
    d: "M342.072,247.533c-1.558-9.406-3.291-15.15-3.291-15.15l-20.817-6.816 c-0.187,2.826-12.64,52.092-14.007,72.724c-0.429,6.472-2.012,13.05-1.608,19.556c0.374,6.019,1.224,8.482,3.683,13.4 c2.73,5.461,3.075,14.509,3.76,20.683c0.87,7.845,0.706,17.723,1.013,25.456l28.013-1.676 c1.94-17.257,1.999-29.354-2.847-45.909c-1.487-5.08,2.927-11.638,4.197-16.665c1.372-5.434,2.392-10.956,3.096-16.516 c1.147-9.06,2.88-20.606,0.947-29.65"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060"
    },
    d: "M338.818,375.71c-0.891,7.926-1.103,11.329-3.57,18.888 c-8.733,26.759-10.558,52.142-10.558,52.142s-7.634,1.66-12.077-0.434c0,0-0.922-35.691-1.553-60.931 c-0.066-2.635-0.149-5.302-0.255-7.989"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M304.704,328.373 c0,0,2.765,6.659,6.237,7.664"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M343.552,330.69c0,0,3.73,6.171,7.313,6.646 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060"
    },
    d: "M385.437,366.828c-0.661-17.354-2.715-19.068-9.98-34.713 c-2.229-4.801-0.02-10.288,0.485-15.449c0.545-5.578,1.74-14.372,1.605-19.975c-0.22-9.129,1.39-39.74-1.873-48.393 l-12.776-17.613l-30.041,5.429c0.088,1.044,0.176,2.088,0.263,3.132c1.732,20.604,3.464,41.208,5.196,61.813 c0.543,6.464-0.039,13.204,1.333,19.576c1.27,5.896,4.505,11.332,6.57,16.971c2.099,5.733,3.917,11.663,5.517,17.665 c2.033,7.627,3.714,15.369,5.174,22.97c0.507,2.641,0.987,5.265,1.447,7.861c4.396,24.861,9.169,35.472,10.81,60.674 l12.095-0.705c0,0-1.934-27.682,2.702-55.446C385.272,382.781,385.74,374.798,385.437,366.828z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M343.552,330.69"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M343.552,330.69c0,0,3.73,6.171,7.313,6.646 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC82"
    },
    d: "M332.181,127.371c0,0-1.078-8.5,3.269-9.922c2.548-0.834,4.931-3.343,5.406-5.983 c1.162-6.453,2.054-13.122,0.232-18.183l9.437-21.447c0,0,5.538,16.922,8.638,35.399c0.981,5.846,5.962,7.57,7.977,8.752 c4.351,2.553-7.35,29.652-29.072,16.344c-0.094-0.053-0.184-0.112-0.273-0.174C333.446,129.423,335.906,133.708,332.181,127.371 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE9066"
    },
    d: "M340.164,113.496l0.12-0.353c0.264-0.544,0.471-1.105,0.574-1.677 c0.44-2.447,0.84-4.924,1.07-7.333l9.665-6.98C351.592,97.153,349.601,110.784,340.164,113.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M333.307,121.841l1.941-4.318c0,0,1.353-1.656,6.073-2.41c12.571,0.357,22.609-0.96,22.609-0.96 c6.853,1.774,12.379,12.63,13.056,14.758c7.538,23.691-2.278,31.23-5.171,45.926c0,0-1.974,21.974,2.051,34.049 c0.289,0.868-30.307,22.744-47.953,11.251c-4.982-3.245-6.307-11.23-6.307-11.23c3.231-15.23,2.848-22.949-0.098-32.972 c-5.466-18.602-2.086-18.792,1.928-28.013c0.733-1.684,3.796-8.376,4.881-10.739"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.828,138.24c0.3-0.653,1.483-15.009,9.42-20.717l0.24,0.62L325.828,138.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC82"
    },
    d: "M322.897,81.028c0,0,2.386,30.568,15.742,27.48c16.517-3.82,18.89-28.502,17.712-41.758 c-0.562-6.326-6.686-7.578-12.952-8.606C333.655,56.543,321.299,63.667,322.897,81.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29211C"
    },
    d: "M321.819,66.035c2.937-6.507,13.943-13.609,23.76-13.58c9.817,0.029,16.62,6.482,18.115,15.505 c2.428,14.664-8.329,14.334-8.329,14.334s-23.404,4.593-30.737-13.018c-3.526,5.885-0.427,10.819-1.24,15.004 C323.388,84.281,318.883,72.541,321.819,66.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC82"
    },
    d: "M323.538,82.198c0,0-0.566,7.007-1.38,9.6c-0.809,2.576,0.304,4.374,4.803,3.821"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M336.557,93.127 c0,0-2.753,4.595-6.613,3.624"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC82"
    },
    d: "M358.78,88.89c-1.642,2.985-4.824,4.386-7.106,3.131c-2.283-1.256-2.802-4.693-1.16-7.679 c1.643-2.985,4.824-4.387,7.107-3.13C359.903,82.467,360.423,85.905,358.78,88.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M356.333,84.672 c0,0-1.683,0.347-2.13,3.814"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M356.453,87.538 c0,0-0.262-0.812-1.618-1.195"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29201D"
    },
    d: "M328.94,85.334c-0.038,0.655-0.407,1.165-0.824,1.141c-0.416-0.025-0.723-0.575-0.685-1.229 c0.038-0.655,0.407-1.165,0.824-1.141C328.672,84.129,328.979,84.679,328.94,85.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M319.536,161.471"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M346.819,128.829"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M248.105,166.69c0,0-14.951-9.595-10.261-9.33c0,0,9.346,2.836,12.824,4.674 c3.479,1.838,8.575,6.93,8.575,6.93L248.105,166.69z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66B0A9"
    },
    points: "261.455,169.181 247.314,165.074 245.719,179.946 261.482,177.882  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M245.719,179.946c0,0-4.669-2.903-6.111-5.072c-1.548-2.328-9.148-15.867-8.113-16.463 c1.906-1.097,6.952,3.614,9.919,6.157c0.769,0.659,2.197,1.977,5.9,0.506L245.719,179.946z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 232.955,
    y1: 162.591,
    x2: 241.523,
    y2: 167.973
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 236.141,
    y1: 168.742,
    x2: 241.853,
    y2: 171.598
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 238.887,
    y1: 173.465,
    x2: 243.281,
    y2: 175.443
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M246.28,165.35c0,0,1.929-0.713,3.201-1.302 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29201D"
    },
    d: "M324.86,451.121c0,0,4.169,9.72,2.722,15.795c0,0-17.501,1.012-30.952,3.182 c-13.451,2.169-20.828-5.207-11.716-8.678c9.112-3.471,27.626-12.873,27.626-12.873S313.749,457.6,324.86,451.121z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M304.946,451.835 c0,0,2.52,0.141,3.33,3.449"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M300.805,453.241 c0,0,2.52,0.141,3.33,3.449"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M308.724,450.356 c0,0,2.52,0.141,3.33,3.449"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M327.806,81.326c0,0,2.676-0.506,3.833,2.169 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66B0A9"
    },
    points: "358.959,103.944 340.108,114.809 344.421,125.047 364.753,114.423  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66B0A9"
    },
    points: "339.433,111.692 340.849,115.303 335.869,122.248 333.829,118.259  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29201D"
    },
    d: "M340.857,111.467l-1.424,0.225l0.723,1.83C340.156,113.521,340.448,113.317,340.857,111.467z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "333.765,118.427 335.869,122.248  340.523,115.999 344.246,125.173 364.899,114.758  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.388,84.281c0,0,2.153,6.19,5.345,8.14c3.191,1.95,7.623-0.709,10.105,1.595 c0,0,1.029,13.145-6.027,13.296C316.323,107.667,323.388,84.281,323.388,84.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M331.746,102.703c4.501-0.097,5.708-5.471,5.995-9.358c0.394,0.153,0.764,0.363,1.096,0.671 c0,0,1.029,13.144-6.027,13.296c-7.797,0.167-10.3-4.979-10.801-10.445C323.405,100.28,326.249,102.821,331.746,102.703z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M352.843,81.252 c0,0-7.801,9.928-17.728,13.473"
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "339.081,315.844 335.32,250.106  326.782,242.224  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M361.27,453.786c0,0,2.52,0.141,3.33,3.449"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M357.129,455.193c0,0,2.52,0.141,3.33,3.449 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M365.048,452.307c0,0,2.52,0.141,3.33,3.449 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M393.657,318.02l-0.227-2.791c-12.381-30.547-48.06-78.887-64.486-119.703 c-2.994-7.44-7.978-21.164-2.023-32.37c4.028-7.58,9.572-7.44,19.093-17.323c11.402-11.836,18.393-27.547,15.932-29.588 c-2.679-2.221-18.239,10.357-28.829,22.76c-7.081,8.293-12.297,16.931-16.245,25.468c0.356,2.861,1.179,6.503,2.636,11.46 c0.372,1.264,0.702,2.492,0.99,3.703l-26.139,146.292c3.573,0.901,7.01,1.728,10.332,2.496c0.385,0.871,0.826,1.791,1.342,2.823 c0.099,0.198,0.19,0.408,0.283,0.616c-0.001,0-0.001,0.001-0.002,0.001c2.468,5.505,2.82,14.116,3.48,20.066 c0.87,7.845,0.706,17.723,1.012,25.456c0.107,2.687,0.19,5.353,0.255,7.989c0.631,25.239,1.553,60.93,1.553,60.93 c0.006,0.003,0.012,0.005,0.018,0.007l-0.09,2.235c0,0-18.513,9.401-27.626,12.873c-6.689,2.548-4.486,7.196,2.476,8.632 c0.332-2.58,1.102-5.752,3.621-8.234c1.705-1.68,3.456-2.298,5.437-3.035c11.176-4.152,16.763-6.228,19.22-8.345 c5.603-4.83,1.73-14.776,0-29.967c-1.551-13.616-0.022-30.826,3.035-65.245c0.434-4.889,0.863-9.145,0.985-12.701 c7.176,1.361,13.723,2.456,19.664,3.302c-0.451-3.645-1.132-7.356-2.108-11.287c2.86,0.384,5.565,0.694,8.145,0.945 c0.291,0.705,0.569,1.411,0.829,2.121c0.274,0.749,0.528,1.512,0.792,2.268c0.385,1.097,0.763,2.198,1.129,3.306 c0.247,0.754,0.487,1.513,0.726,2.272c1.027,3.239,1.989,6.514,2.87,9.82c2.033,7.627,3.714,15.369,5.174,22.97 c0.507,2.641,0.987,5.265,1.447,7.861c4.396,24.861,9.169,35.472,10.81,60.674l0.015-0.001l-0.159,3.942 c0,0-18.513,9.402-27.625,12.873c-4.856,1.85-5.028,4.809-2.094,6.841c1.778-1.049,4.12-3.316,8.863-6.083 c12.692-7.405,20.97-5.749,23.772-12.139c1.264-2.883,0.658-5.682,0.253-7.587c-10.867-51.074-16.3-76.611-15.679-84.718 c0.261-3.406,0.841-8.111,0.167-12.147c11.302,0.848,19.603,0.503,25.639-0.64c-1.299-3.444-3.102-7.03-5.616-12.351 C396.748,330.389,393.657,318.02,393.657,318.02z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.711,146.311c0.557-5.115,4.232-28.137-13.845-31.457c-7.176-1.318-13.51,6.215-13.51,6.215 l-31.049,45.219l2.929,26.948l-9.227,126.979c38.665,13.181,78.648-2.197,78.648-2.197L379.711,146.311z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6677B0"
    },
    d: "M341.03,110.472c-0.007,0.038-0.013,0.076-0.02,0.114 C341.017,110.548,341.023,110.51,341.03,110.472z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M368.466,125.574c1.954,3.108,11.131,19.332-1.034,26.791 c-10.152,6.225-48.414,36.906-56.964,38.529c-9.702,1.841-40.802-6.151-52.469-12.156l2.05-10.948 c0,0,39.543,4.082,46.267,8.382C306.317,176.173,356.771,106.97,368.466,125.574z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M306.248,176.061c0,0-0.854,1.111-5.163,1.67"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 363.34,
    y1: 156.33,
    x2: 318.67,
    y2: 186.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 266.091,
    y1: 168.376,
    x2: 263.821,
    y2: 181.264
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 261.936,
    cy: 170.738,
    r: 0.934
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M348.548,274.717c-12.445,0.673-15.475-12.318-16.194-19.689l-0.209,0.015 c0,0-0.92,25.541,16.403,24.605c15.15-0.819,16.56-13.65,16.038-21.306C364.038,265.606,360.745,274.057,348.548,274.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M332.144,255.043l31.635-2.343 c0,0,6.444,25.777-15.232,26.948C331.224,280.584,332.144,255.043,332.144,255.043z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M131.888,198.951c0,0,1.557,39.134,1.722,48.213c0.165,9.079-2.825,10.979-2.296,20.95 c0.529,9.971,7.175,39.03,7.175,39.03l9.508-5.072c0,0,2.187-35.752,0.465-49.957c-1.636-13.494,6.003-56.619,6.003-56.619 L131.888,198.951z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.04,
    y: 345.743,
    style: {
      fill: "#606060"
    },
    width: 3.587,
    height: 118.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.538,
    y: 345.743,
    style: {
      fill: "#606060"
    },
    width: 3.587,
    height: 118.812
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.375,350.909H123.643c-2.817,0-5.1-2.283-5.1-5.1v-27.251c0-2.817,2.283-5.1,5.1-5.1h135.732 c2.817,0,5.1,2.283,5.1,5.1v27.251C264.475,348.626,262.191,350.909,259.375,350.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEE0B6"
    },
    d: "M260.385,329.555H118.543v10.354c0,6.075,2.73,11,6.098,11h133.735c3.368,0,6.098-4.925,6.098-11 v-13.245C263.391,328.442,261.965,329.555,260.385,329.555z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M224.994,196.841c0,0,4.048,14.988,4.301,39.747c0.257,25.135-0.112,41.214-0.112,41.214 l-10.857,3.933l-9.913-86.702L224.994,196.841z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBC82"
    },
    points: "223.547,450.307 224.208,431.862 238.389,436.396 238.745,445.201 237.588,456.495  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29201D"
    },
    d: "M223.594,448.366c0,0-5.126,11.954-3.348,19.424c0,0,21.521,1.245,38.063,3.913 c16.542,2.668,25.612-6.403,14.407-10.672c-11.205-4.269-33.972-15.83-33.972-15.83S237.258,456.333,223.594,448.366z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M248.276,448.975 c0,0-3.099,0.173-4.095,4.241"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M253.369,450.704 c0,0-3.099,0.173-4.095,4.241"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M243.629,447.156 c0,0-3.099,0.173-4.094,4.241"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBC82"
    },
    points: "191.691,451.742 192.353,433.297 206.533,437.831 206.889,446.636 205.733,457.93  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29201D"
    },
    d: "M191.739,449.801c0,0-5.126,11.954-3.348,19.424c0,0,21.521,1.245,38.063,3.913 c16.542,2.668,25.613-6.403,14.407-10.672c-11.205-4.269-33.972-15.83-33.972-15.83S205.403,457.768,191.739,449.801z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M216.421,450.41c0,0-3.099,0.173-4.095,4.241 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M221.513,452.139 c0,0-3.099,0.173-4.095,4.241"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M211.774,448.591 c0,0-3.099,0.173-4.095,4.241"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#856042"
    },
    d: "M261.892,329.529c0.962-6.758,5.15-15.951,2.87-22.385c-1.195-3.371-10.486-12.608-12.34-13.488 l-45.63-32.716c0,0-32.571-29.059-43.048-12.484c-7.719-1.088-14.169,6.435-12.914,27.981 c0.098,1.675-3.444,40.895,30.715,50.854c-0.168,18.668,0.435,43.689,3.723,66.235c6.027,41.326,4.305,54.24,4.305,54.24 l23.966-3.263c0,0,6.612-71.73,6.217-117.597c2.483,0.483,5.081,0.905,7.806,1.252c-4.359,15.048-2.152,37.394-3.121,56.758 c-2.152,43.048-5.788,59.459-5.788,59.459l22.243,2.4C240.895,446.776,256.762,365.563,261.892,329.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M185.267,393.526c6.027,41.326,4.305,54.24,4.305,54.24l1.662-0.226 c-0.268-8.943,2.107-22.061,0.045-49.064c-2.488-32.583-7.835-38.166-2.682-54.801c4.423-14.28,11.664-20.82,8.048-29.125 c-4.462-10.249-18.601-7.434-25.676-20.311c-4.799-8.733-0.701-14.407-6.132-20.311c-3.547-3.856-9.045-5.51-14.087-5.897 c-0.118,2.527-0.101,5.317,0.079,8.405c0.098,1.675-3.444,40.895,30.715,50.854C181.376,345.959,181.979,370.98,185.267,393.526z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M219.763,328.19l-0.795,36.006C219.501,351.656,219.826,339.218,219.763,328.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M206.791,260.94c0,0-4.983-4.445-11.677-8.867 c-8.218-1.237-17.758-0.923-26.445,1.93c-6.528,2.143-12.928,5.835-17.551,9.69c-0.453,3.547-0.579,7.767-0.289,12.744 c0.009,0.158-0.014,0.65-0.035,1.417c2.388,0.55,5.67,1.109,10.21,1.632c20.264,2.335,33.805,3.693,45.795-4.79 c2.712-1.919,6.628-4.697,8.272-7.82L206.791,260.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M213.224,164.118c0,0,11.67,1.372,15.579,36.117c0,0-9.121,4.343-23.019,0.869L213.224,164.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M216.766,268.092l3.543,2.54c0.965-1.367,1.612-3.669,2.138-6.155 c2.579-12.193,0.365-19.723-0.255-35.256c-0.43-10.774-0.646-16.161-0.511-18.905c0.362-7.372,1.246-11.723-1.533-14.563 c-2.322-2.373-5.116-12.065-8.175-10.986c-1.282,0.452-2.415,1.325-3.413,2.54l-2.775,13.797c1.174,0.294,2.3,0.513,3.404,0.703 L216.766,268.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M145.071,165.461c0,0-15.672,5.512-16.161,47.37c0,0,1.954,8.795,28.339,2.932 C157.249,215.762,170.218,182.918,145.071,165.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M210.7,163.561c0,0-7.41-0.07-12.788-1.619c-3.153-0.908-5.544-3.491-6.24-6.698 c-1.704-7.841-3.085-15.957-1.079-22.225l-22.347-17.732c0,0,1.303,13.325,0.854,35.583 c-0.146,7.253-10.87,10.261-13.283,11.794c-5.209,3.312,0.582,2.681-9.791,4.285c0,0,23.987,30.91,49.966,13.687 c0.112-0.069,0.22-0.145,0.326-0.225C201.519,176.878,206.422,171.472,210.7,163.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4966C"
    },
    d: "M175.1,140.213c0,0,1.695,11.866,15.93,12.059l-0.706-4.454L175.1,140.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M195.336,113.646c0,0,12.089,29.29-1.48,34.175c-16.782,6.042-29.723-15.33-36.242-27.722 c-3.111-5.913,0.952-11.34,6.544-14.996C179.702,94.941,183.373,100.633,195.336,113.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#856042"
    },
    d: "M187.739,99.774c-6.307-4.078-15.123-4.917-23.786,0.707 c-8.664,5.624-13.737,15.558-9.898,24.382c11.456,26.331,15.559,16.756,15.559,16.756s-6.668-5.984-1.026-9.575 c6.704-4.266,0.444-9.212,2.736-13.679c0,0,16.385-8.341,12.824-15.388c6.266,7.947,8.244,6.292,11.712,12.097 C195.86,115.074,194.046,103.852,187.739,99.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66B0A9"
    },
    d: "M215.57,189.803c-0.09-2.867-2.329-25.679-2.346-25.685c-2.576-0.818-3.072-0.729-5.76-1.004 c-2.781-0.285-6.588-0.778-9.581-1.549c-2.168-0.559,1.7,7.711-14.248,9.805c-15.356,0.987-23.091-11.01-23.091-11.01 c-6.303,3.305-16.515,3.688-16.258,6.408c5.837,61.709,5.889,88.59,6.113,99.767c0.287,14.349,20.232,13.775,62.85,3.731 C225.818,267.304,216.261,211.865,215.57,189.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M180.974,276.591c-3.721-0.543-9.098-0.074-14.605-4.194 c-7.709-5.769-9.407-15.855-9.964-19.161c-1.668-9.904,2.346-11.335,1.533-23.376c-0.596-8.82-3.256-15.543-5.748-21.844 c-2.33-5.889-4.019-10.152-5.411-12.809c3.362,41.907,3.433,62.045,3.619,71.329 C150.599,276.584,160.456,279.307,180.974,276.591z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 148.676,
    y1: 217.031,
    x2: 146.57,
    y2: 194.348
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 215.421,
    y1: 184.767,
    x2: 215.974,
    y2: 202.682
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M189.623,120.072 c0,0,2.188,4.443,4.013,5.96c1.813,1.507,1.847,3.353-1.716,5.076"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#856042",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M178.355,125.574 c0,0,1.201-3.065,4.159-2.305"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M185.624,125.882 c0,0-1.201,3.065-4.159,2.305"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M197.764,120.068 c0,0-1.201,3.065-4.159,2.305"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#856042",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M191.598,119.441 c0,0,1.201-3.065,4.159-2.305"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M168.093,141.06c3.154,1.703,6.766,1.128,8.069-1.284c1.302-2.412-0.199-5.747-3.353-7.451 c-3.154-1.702-6.767-1.128-8.069,1.285C163.437,136.022,164.938,139.357,168.093,141.06z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M166.608,135.265 c0,0,1.763-1.146,4.719,2.509"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M168.385,138.292 c0,0-0.269-1.008,0.871-2.301"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M202.199,185.176 c0,0,21.237,57.971-1.722,71.746"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M161.16,173.696 c0,0,15.356,30.563,28.124,25.255"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M167.187,197.803 c0,0,10.905,49.361,29.272,45.918"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M195.598,283.324 c0,0,24.214,14.062,24.214,23.246s0,20.663,0,20.663"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M181.544,327.291c0,0,2.001,2.525,9.606,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M226.88,328.094c0,0,2.619,3.121,10.331,1.435 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M258.725,467.839c-18.778-3.832-32.957-14.946-32.957-14.946 s0.766-24.526,1.916-36.406c1.15-11.88,15.712-93.506,13.413-95.039c-2.299-1.533-26.027-31.073-33.436-42.058l-0.777,0.864 c-1.741,1.936-3.063,4.212-3.881,6.685l-0.324,0.978c0,0,15.68,10.155,16.83,16.542c1.15,6.387,0.287,22.195,0.287,22.195 l-0.006,0.259c2.472,0.481,5.058,0.9,7.77,1.246c-4.359,15.047-2.152,37.394-3.121,56.758 c-2.152,43.048-5.788,59.459-5.788,59.459l5.088,0.549l-0.124,3.453c-0.007-0.004-0.014-0.008-0.022-0.012 c0,0-0.99,2.31-1.949,5.532c6.646,3.183,14.123,6.628,19.216,8.568c5.217,1.987,6.035,5.015,3.755,7.415 c4.586,0.51,9.314,1.116,13.694,1.822c8.462,1.365,14.959-0.344,17.797-2.909C271.988,469.369,266.466,469.419,258.725,467.839z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M137.676,303.15l-6.865,9.027c0,0-6.781,3.56-6.526,6.526c0.396,4.623,0.424,6.187,1.695,6.187 c1.271,0,1.653-6.738,1.653-6.738l6.611-5.467l13.716-1.452l0.072-9.614L137.676,303.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M202.917,287.773c0,0-0.574-3.731,5.022-8.466"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M135.277,308.407c-1.061,0.212-9.722,9.025-9.722,9.025s0.674,10.298,3.221,10.086 c2.547-0.212,0.848-9.238,0.848-9.238l10.959-9.236L135.277,308.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M141.528,308.087c-1.024,0.349-8.091,8.412-8.091,8.412s1.021,12.643,3.518,12.099 c2.497-0.543,1.398-11.591,1.398-11.591l7.713-5.509L141.528,308.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M139.192,309.585c-1.061,0.212-10.247,8.186-10.247,8.186s0.674,11.824,3.221,11.612 c2.547-0.212,2.458-11.612,2.458-11.612l9.874-7.549L139.192,309.585z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "134.327,323.359 133.825,316.256  138.345,311.879  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "133.323,311.951 129.233,316.471  129.951,325.726  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#29201D",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "129.018,313.888 126.005,317.691  126.507,324.363  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BE89"
    },
    d: "M147.816,305.817c0,0,0.019,3.822,2.798,4.843c2.78,1.021,3.609,1.495,3.609,1.495 s1.969,1.332-1.566,1.917c-3.536,0.585-10.987-0.501-10.987-0.501L147.816,305.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#120E0C",
      strokeWidth: 0.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M146.165,250.249 c0,0-2.152,1.076-3.013,4.735c0,0-0.933-5.238-2.224-6.242"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M135.584,261.667c0.538-6.657,2.008-5.813,3.577-14.307 c3.543-19.185-3.057-28.359-4.088-45.475c-0.913-15.149,3.154-26.237,5.978-33.498c-4.679,4.69-11.814,16.41-12.141,44.445 c0,0,0.436,1.949,3.647,3.4c0.444,11.703,0.961,25.912,1.052,30.933c0.165,9.08-2.825,10.979-2.296,20.95 c0.406,7.655,4.414,26.547,6.256,34.917c0.191-0.216,0.38-0.458,0.569-0.743C143.711,293.862,134.079,280.288,135.584,261.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M171.858,129.543c-3.321-2.985-4.278-6.038-6.127-12.478 c-1.597-5.562,0.157-10.734,1.022-13.285c0.794-2.342,1.84-4.372,2.971-6.11c-1.912,0.647-3.844,1.561-5.77,2.812 c-8.664,5.624-13.737,15.558-9.898,24.382c9.392,21.588,13.84,19.042,15.139,17.423c-0.004,2.69-0.031,5.551-0.093,8.585 c-0.095,4.724-4.677,7.646-8.528,9.534c-0.018-0.027-0.03-0.044-0.03-0.044c-2.315,1.214-5.157,2.033-7.814,2.719 c6.905,1.707,15.305,0.6,21.177-4.627c4.046-3.602,13.981-5.489,16.209-9.855C182.677,145.096,176.471,137.061,171.858,129.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#6677B0"
    },
    d: "M365.069,152.64l-45.637,31.116l-0.959,5.369c5.638-2.623,10.872-5.842,16.13-9.085 c12.857-7.928,22.253-16.864,28.741-24.143L365.069,152.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelf);
export default __webpack_public_path__ + "static/media/self.c4953d3cab91db1d6bae1f906c0cff2c.svg";
export { ForwardRef as ReactComponent };